export const getIdleConfirmTimeout = () => Date.now() + (1000 * 60) * 5 + 1000;
